import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import appTextIcon from "../../../assets/images/header-text-icon.svg";
import whatsappIcon from "../../../assets/images/whatsapp-icon.svg";
import workspaceAppIcon from "../../../assets/images/workspace-detail-background.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import {
  getCalendarRealLifeImages,
  getTermaAndConditionsText,
} from "utils/utils";
import { STORAGE_KEY, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";
import ExpandableView from "components/elements/ExpandableView";

const MBStudioDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedTabBar } = useTabBar();
  const { handleAppExit } = useLogout();

  useEffect(() => {
    trackDetailView("mb_studio", "MB_STUDIO");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      STORAGE_KEY.CALENDAR_SELECTED_TAB,
      CALENDAR_RESERVATION_TYPE.MB_STUDIO,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  const openWhatsappChannel = () => {
    handleAppExit(WEB_LINK.WHATSAPP_CHANNEL);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Mind Body <span style={{ color: "#C2B58C" }}>Studio</span>
          </span>
        </div>
        <div className="calendar_detail-app-icon-container">
          <img src={workspaceAppIcon} alt="location-logo" />
        </div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>Sabe Hub, Mohali</span>
                <span className="sub-text">Floor 1</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            bout <span style={{ color: "#C2B58C" }}>MB Studio</span>
          </span>
          <div className="divider"></div>
          <div className="sub-title">
            Creativity, inclusivity, and purposeful engagement.
            <br />
            <br />
            Each event is designed to bring people together around shared goals
            & meaningful experiences.
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getCalendarRealLifeImages(
              CALENDAR_RESERVATION_TYPE.MB_STUDIO,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <div className="calendar_detail-contact-detail-container">
          <div className="footer-container">
            <div className="title">Contact Details</div>
            <div className="sub-container">
              <img src={appTextIcon} alt="sabe-text-logo" />
              <img
                src={whatsappIcon}
                alt="whatsapp-logo"
                onClick={openWhatsappChannel}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
        <ExpandableView title="Terms &" subTitle="Conditions">
          <div className="calendar-detail-expanded-container">
            <div className="divider"></div>
            <div className="sub-container">
              <div className="sub-title">
                {getTermaAndConditionsText(
                  CALENDAR_RESERVATION_TYPE.MB_STUDIO,
                )}
              </div>
            </div>
          </div>
        </ExpandableView>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve Now
        </button>
      </div>
    </div>
  );
};

export default MBStudioDetailScreen;
